// Save the initial state when the page loads
const initialState = window.location.origin;

// Selecteurs
const buttonsStep = {
    step1: document.querySelector(".btn-step1"),
    step2: document.querySelector(".btn-step2"),
    step3: document.querySelector(".btn-step3"),
    back1: document.querySelector(".btn-back1"),
    back2: document.querySelector(".btn-back2"),
    back3: document.querySelector(".btn-back3"),
};

const steps = {
    step0: document.querySelector(".step0"),
    step1: document.querySelector(".step1"),
    step2: document.querySelector(".step2"),
    step3: document.querySelector(".step3"),
};

const stepsCompleted = {
    step1: false,
    step2: false,
    step3: false
};

const cover = document.querySelector(".container-cover");
const blurs = document.querySelectorAll(".form-step__blur");

const supportedCountries = ["be", "de", "fr", "nl", "dk", "ch", "lu", "gb", "ie", "au"];

var directContact = false;

fetch("/ip.php").then((res) => res.json()).then((res) => {
    if (res.status == "success" && res.countryCode && !supportedCountries.filter((m) => m === res.countryCode.toLowerCase()).length) {
        document.querySelector(".btn-step1").setAttribute("disabled", true);
        document.getElementById("unsupported-country").style.display = "block";
        document.querySelector(".step1").style.pointerEvents = "none";
        document.querySelector(".step2").style.pointerEvents = "none";
        document.querySelector(".step3").style.pointerEvents = "none";
    }
});



fetch("/generate-csrf.php").then(response => response.json()).then(data => {
    let csrfToken = data.message;
    document.getElementById("csrf_token").value = csrfToken;
    document.getElementById("csrf_token_2").value = csrfToken;
    // Further processing or assignments with the retrieved data
}).catch(error => {
    console.error("Error:", error);
});

// Fonctions
function toggleSteps(activeStep, waitingSteps) {
    steps[activeStep].classList.add("step-active");
    // window.location.hash = "current-step-" + activeStep;
    window.history.pushState({}, null, "/" + steps[activeStep].getAttribute("data-step"));

    steps[activeStep].classList.remove("step-wait");
    steps[activeStep].classList.remove("step-inactive");
    
    waitingSteps.forEach(step => {
        steps[step].classList.add("step-wait");
        steps[step].classList.remove("step-active");
    });
}

function resetStep() {
    steps.step0.classList.remove("step-inactive");
    steps.step1.classList.remove("step-active");
    steps.step2.classList.remove("step-wait");
    steps.step3.classList.remove("step-wait");
}

function applyBlurEffect(add) {
    for (const blur of blurs) {
        add ? blur.classList.add("full") : blur.classList.remove("full");
    }
}

// Evenements
buttonsStep.step1.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleSteps("step1", ["step2", "step3"]);
    steps.step0.classList.add("step-inactive");
    steps.step0.classList.remove("step-active");
    cover.style.display = "none";
    applyBlurEffect(true);
    directContact = false;
});

steps.step1.addEventListener("click", () => {
    toggleSteps("step1", ["step2", "step3"]);
    steps.step0.classList.add("step-inactive");
    steps.step0.classList.remove("step-active");
    cover.style.display = "none";
    applyBlurEffect(true);
    directContact = false;
});

buttonsStep.back1.addEventListener("click", (e) => {
    e.stopPropagation();
    resetStep();
    cover.style.display = "flex";
    applyBlurEffect(false);

    const inputs = document.querySelectorAll(".step1 select, .step1 input:not(.choices__input--cloned)");
    inputs.forEach(input => {
        if (!validator.isEmpty(input.value)) {
            stepsCompleted.step1 = true; // Met à jour l"état de progression
        }
    });

    window.history.pushState({}, null, initialState);
});

buttonsStep.back2.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleSteps("step1", [ "step2", "step3"]);
    const inputs = document.querySelectorAll(".step2 select, .step2 input:not(.choices__input--cloned)");
    inputs.forEach(input => {
        if (!validator.isEmpty(input.value)) {
            stepsCompleted.step2 = true; // Met à jour l"état de progression
        }
    });
});

buttonsStep.back3.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleSteps("step2", ["step1", "step3"]);
});


// let choices = [];
const selectMultiple = document.getElementById("input2-step2");
const handlerSelectMultiple = selectMultiple.parentNode;

document.addEventListener("click", (event) => {
    const target = event.target;
    if (!handlerSelectMultiple.contains(target) && target.tagName !== "INPUT") {
        handlerSelectMultiple.classList.remove("is-open");
    }
});

handlerSelectMultiple.addEventListener("click", () => {
    handlerSelectMultiple.classList.toggle("is-open");
});

function initDropdownMultiple() {
    if (document.getElementById("custom-dropdown")) 
        document.getElementById("custom-dropdown").remove();
    
    updateOpenerContent();
    const customSelectPanel = document.createElement("div");
    customSelectPanel.id = "custom-dropdown";
    customSelectPanel.classList.add("custom-select-panel");
    customSelectPanel.setAttribute("role", "listbox");
    customSelectPanel.addEventListener("click", (event) => {
        event.stopPropagation();
    });

    // Boucle à travers les options du select
    for (const option of selectMultiple.options) {
        const label = document.createElement("label");
        label.classList.add("custom-select-option");
        label.setAttribute("data-value", option.value);
        label.setAttribute("role", "option");

        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.name = "chassis";
        checkbox.value = option.value;

        const labelText = document.createTextNode(option.text);
        label.appendChild(checkbox);
        label.appendChild(labelText);
        if (option.selected) 
            checkbox.checked = true;
        
        customSelectPanel.appendChild(label);
    }

    // Ajoutez customSelectPanel à la fin de handlerSelectMultiple
    handlerSelectMultiple.appendChild(customSelectPanel);

    // Écoute les changements sur les checkboxes
    customSelectPanel.addEventListener("change", (event) => {
        if (event.target.tagName === "INPUT") {
            const value = event.target.value;
            const option = selectMultiple.querySelector(`option[value="${value}"]`);
            if (option) {
                option.selected = event.target.checked;
                updateOpenerContent(); // Met à jour le contenu de l'opener

            }
        }
    });
}

function updateOpenerContent() {
    const selectedOptions = [...selectMultiple.selectedOptions];
    const openerSpan = handlerSelectMultiple.querySelector(".custom-select-opener span");
    openerSpan.innerHTML = ""; // Vide le contenu actuel

    selectedOptions.forEach(option => {
        const div = document.createElement("div");
        div.textContent = option.textContent;
        openerSpan.appendChild(div);
    });
}





function initChoices(){
    const selects = document.querySelectorAll("select:not(select#input2-step2)");
    selects.forEach((select)=>{
        let custom_select = customSelect(select);
        //select.querySelectorcustom-select-opener
        choices.push(custom_select);


    });
    initDropdownMultiple();

}

// initChoices();
function resetChoices() {
    choices.forEach((item) => {
        item[0].destroy();
    });
    choices = [];
    initChoices();
}


// Incrémentation
const increaseButton = document.querySelector(".increase");
const decreaseButton = document.querySelector(".decrease");
const quantityInput = document.querySelector("#quantity");

function updateQuantity(increment) {
    if(quantityInput.value === "") {
        quantityInput.value = 0;
    }

    let newValue = parseInt(quantityInput.value) + increment;
    if (newValue >= quantityInput.min && newValue <= quantityInput.max) {
        quantityInput.value = newValue;
    }
}

increaseButton.addEventListener("click", () => updateQuantity(1));
decreaseButton.addEventListener("click", () => updateQuantity(-1));
let allInputsValid = true;
// Validation avec paramètres
function validateSelect(currentStep, activeStep, waitingSteps, additionalAction = () => {}) {
    // Sélectionnez tous les inputs de l"étape active
    const inputs = document.querySelectorAll(`.${currentStep} select, .${currentStep} input:not(.choices__input--cloned)`);
    let allInputsValid = true;

    if (allInputsValid) {
        stepsCompleted[currentStep] = true; // Met à jour l"état de progression
        toggleSteps(activeStep, waitingSteps);
        additionalAction();
    } else {
        console.error("Veuillez remplir tous les champs.");
    }
}

function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}


// Actions supplémentaires spécifiques à chaque bouton
const hideCoverAndApplyBlur = () => {
    cover.style.display = "none";
    applyBlurEffect(true);
};

// Assignation des écouteurs d"événements
buttonsStep.step2.addEventListener("click", (e) => {
    e.stopPropagation();
    const inputs = document.querySelectorAll(".step1 select, .step1 input:not(.choices__input--cloned)");
    let allInputsValid = true;
    document.querySelectorAll(".step2 .erreur-validation").forEach(el => el.remove());

    inputs.forEach(input => {
        if (validator.isEmpty(input.value)) {
            allInputsValid = false;
            const errorMessage = document.createElement("div");
            errorMessage.classList.add("erreur-validation");
            errorMessage.setAttribute("data-i18n-key", "messages.steps.contactDetails.incompleteFieldMessage");
            errorMessage.textContent = incompleteFieldMessage;
            insertAfter(errorMessage, input.parentNode);
        }
    });
    if (allInputsValid == true) {
        validateSelect("step1", "step2", ["step1", "step3"], hideCoverAndApplyBlur);
        directContact = false;
    }
});

steps.step2.addEventListener("click", () => {
    document.querySelectorAll(".step1 .erreur-validation").forEach(el => el.remove());

    const inputs = document.querySelectorAll(".step1 select, .step1 input:not(.choices__input--cloned)");
    inputs.forEach(input => {
        if (!validator.isEmpty(input.value)) {
            stepsCompleted.step1 = true; // Met à jour l"état de progression
            directContact = false;
        } else {
            const errorMessage = document.createElement("div");
            errorMessage.classList.add("erreur-validation");
            errorMessage.setAttribute("data-i18n-key", "messages.steps.contactDetails.incompleteFieldMessage");
            errorMessage.textContent = incompleteFieldMessage;
            insertAfter(errorMessage, input.parentNode);
        }
    });

    if(stepsCompleted.step1 == true){
        validateSelect("step1", "step2", ["step1", "step3"], hideCoverAndApplyBlur);
        steps.step0.classList.add("step-inactive");
    }
    else{
        toggleSteps("step1", ["step2", "step3"]);
        steps.step0.classList.add("step-inactive");
        steps.step0.classList.remove("step-active");
        cover.style.display = "none";
        applyBlurEffect(true);
    }
});

buttonsStep.step3.addEventListener("click", (e) => {
    e.stopPropagation();
    const inputs = document.querySelectorAll(".step2 select, .step2 input:not(.choices__input--cloned)");
    let allInputsValid = true;
    document.querySelectorAll(".erreur-validation").forEach(el => el.remove());

    inputs.forEach(input => {
        if (validator.isEmpty(input.value)) {
            allInputsValid = false;
            const errorMessage = document.createElement("div");
            errorMessage.classList.add("erreur-validation");
            errorMessage.setAttribute("data-i18n-key", "messages.steps.contactDetails.incompleteFieldMessage");
            errorMessage.textContent = incompleteFieldMessage;
            insertAfter(errorMessage, input.parentNode);
        }
    });
    if(allInputsValid == true){
        validateSelect("step2", "step3", ["step1", "step2"], hideCoverAndApplyBlur);
        directContact = false;
    }
});

steps.step3.addEventListener("click", () => {
    // Réévaluer l"état de complétion pour step1 et step2
    const inputsStep1 = document.querySelectorAll(".step1 select, .step1 input:not(.choices__input--cloned)");
    const allInputsStep1Filled = validateAndShowErrors(inputsStep1, "step1");

    const inputsStep2 = document.querySelectorAll(".step2 select, .step2 input:not(.choices__input--cloned)");
    const allInputsStep2Filled = validateAndShowErrors(inputsStep2, "step2");

    if (!allInputsStep1Filled) {
        // Si l"étape 1 n"est pas complète, rediriger vers l"étape 1
        toggleSteps("step1", ["step2", "step3"]);
    steps.step0.classList.add("step-inactive");
    steps.step0.classList.remove("step-active");
    cover.style.display = "none";
    applyBlurEffect(true);
    } else if (!allInputsStep2Filled) {
        // Si l"étape 2 n"est pas complète, rediriger vers l"étape 2
        validateSelect("step1", "step2", ["step1", "step3"], hideCoverAndApplyBlur);
        steps.step0.classList.add("step-inactive");
        validateAndShowErrors(inputsStep2, "step2");

    } else {
        // Si les étapes 1 et 2 sont complètes, continuer à l"étape 3
        validateSelect("step2", "step3", ["step1", "step2"], hideCoverAndApplyBlur);
            steps.step0.classList.add("step-inactive");
    }
});

function validateAndShowErrors(inputs, step) {
    let allInputsValid = true;

    // Supprimer les anciens messages d"erreur pour cette étape
    document.querySelectorAll(`.${step} .erreur-validation`).forEach(el => el.remove());

    inputs.forEach(input => {
        if (validator.isEmpty(input.value)) {
            allInputsValid = false;
            showErrorMessage(input, incompleteFieldMessage);
        }
    });

    return allInputsValid;
}

function showErrorMessage(input, message) {
    const errorMessage = document.createElement("div");
    errorMessage.classList.add("erreur-validation");
    errorMessage.setAttribute("data-i18n-key", "messages.steps.contactDetails.incompleteFieldMessage");
    errorMessage.textContent = message;

    insertAfter(errorMessage, input.parentNode);
}

// Ajoutez d"autres boutons ici de manière similaire si nécessaire
const newLabel = "";

document.querySelectorAll(".file-input").forEach(function(input) {
    input.addEventListener("change", function() {
        // Show loader
        var wrapperFile = this.closest(".wrapper-file");
        wrapperFile.querySelector("label").style.display = "none";
        var newLabel = wrapperFile.querySelector(".file-name");
        if (!newLabel) {
            newLabel = document.createElement("label");
            newLabel.setAttribute("for", this.id);
            newLabel.classList.add("file-name");
            wrapperFile.appendChild(newLabel);
        }
        newLabel.textContent = "Loading...";
        // Simulate a delay to show the loader (remove this in production)
        var fileName = "";
        if (this.files && this.files.length > 0) {
            fileName = this.files[0].name; // If multiple files uploaded, this takes the first.
        }
        newLabel.textContent = fileName;
        var spanElement = wrapperFile.querySelector(".remove-file");
        if (!spanElement) {
            spanElement = document.createElement("span");
            spanElement.classList.add("remove-file");
            spanElement.style.cursor = "pointer";
            spanElement.textContent = "×";
            newLabel.appendChild(spanElement);
            spanElement.addEventListener("click", function() {
                var fileInput = this.closest(".wrapper-file").querySelector(".file-input");
                fileInput.value = ""; // Clear the file input
                this.closest(".wrapper-file").querySelector("label").style.display = "flex";
                newLabel.remove();
            });
        }
    });
});


// Remove file handler



//Submit

// const incompleteFieldMessage = document.querySelector("body").dataset.requireField;
// const incompleteMailMessage = document.querySelector("body").dataset.requireEmail;
// const incompletePhoneMessage = document.querySelector("body").dataset.requirePhone;

var incompleteFieldMessage = translate("messages.steps.contactDetails.incompleteFieldMessage");
var incompleteMailMessage = translate("messages.steps.contactDetails.incompleteFieldMessage");
var incompletePhoneMessage = translate("messages.steps.contactDetails.incompleteFieldMessage");

const btnSubmit = document.querySelectorAll(".btn-submit");

btnSubmit.forEach(function(element){
    element.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault(); // Empêche la soumission par défaut du formulaire
        const parentForm = element.closest("form");
        const inputsStep3 = parentForm.querySelectorAll(".step3 input, .step3 textarea, .step3 select, .step3 input:not(.choices__input--cloned)");
        const inputStep3Email = parentForm.querySelector('.step3 input[type="email"]');
        parentForm.querySelectorAll(".step3 .erreur-validation-submit, .step3 .erreur-validation-submit-select").forEach(el => el.remove());
    
        let allValid = true; // Variable pour suivre l"état de validation
    
        inputsStep3.forEach(input => {
            if (validator.isEmpty(input.value) && input == parentForm.querySelector(".step3 select")) {
                showErrorMessageSubmitSelect(input, incompleteFieldMessage);
                allValid = false;
            }

            if ((input.required) && (validator.isEmpty(input.value))) {
                let isTextInput = Array.from(parentForm.querySelectorAll('input[type="text"]')).includes(input);
                if (isTextInput ) {
                    showErrorMessageSubmit(input, incompleteFieldMessage);
                    allValid = false;
                }
            }

            if (validator.isEmpty(input.value) && input == parentForm.querySelector("textarea") ) {
                showErrorMessageSubmit(input, incompleteFieldMessage);
            }

            if (validatePhoneNumber(parentForm.querySelector('input[type="tel"]').value, ["fr-FR", "en-US", "fr-BE", "nl-NL", "de-DE"]) == false && input == parentForm.querySelector('input[type="tel"]')) {
                showErrorMessageSubmit(input, incompletePhoneMessage);
            }
            
            if (checkEmail(inputStep3Email.value) == false && input == inputStep3Email) {
                showErrorMessageSubmit(input, incompleteMailMessage);
                allValid = false;
            }
        });
        if (allValid) {
            document.querySelector(".popup-processing").classList.add("open");

            const formData = new FormData(parentForm);
            var recaptchaValue ="";
            formData.append("lang", lang);
            formData.append("source", directContact ? "formulaire" : "devis");
            
            if (directContact)
                recaptchaValue = document.getElementById("recaptcha_token_2").value;
            else 
                recaptchaValue = document.getElementById("recaptcha_token").value;

            formData.append("g-recaptcha-response", recaptchaValue);  

            fetch("/submit.php", { 
                method: "POST", 
                body: formData 
            }).then(response => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                return response.json(); // Assuming server returns JSON response
            })
            .then(data => {
                // Handle successful response data
                if (data.data) {
                    document.querySelector(".popup-processing").classList.remove("open");
                    document.querySelector(".popup").classList.add("open");
                    let href = document.querySelector("[data-redirection]").href;
                    window.location.hash = parentForm.getAttribute("data-success-url");
                    var timeleft = 5 ;
                    var downloadTimer = setInterval(function(){
                        if(timeleft <= 0) {
                            clearInterval(downloadTimer);
                            window.location.href = href;
                            
                        }
                        document.querySelector("[data-timer]").innerHTML = timeleft;
                        timeleft -= 1;
                    }, 1000);
                } else {
                    // handle server error side 
                    console.error("Cannot send message :", data);
                    document.querySelector(".popup-processing").classList.remove("open");
                    document.querySelector(".popup-error").classList.add("open");
                    let href = document.querySelector("[data-redirection]").href;
                    window.location.hash = parentForm.getAttribute("data-success-url");
                    var timeleft = 5 ;
                    var downloadTimer = setInterval(function(){
                        if(timeleft <= 0) {
                            clearInterval(downloadTimer);
                            window.location.href = href;
                            
                        }
                        document.querySelector("[data-timer]").innerHTML = timeleft;
                        timeleft -= 1;
                    }, 1000);
                }
            })
            .catch(error => {
                // Handle errors
                console.error("There was a problem with the fetch operation:", error);
            });
        }
    });
});



function showErrorMessageSubmitSelect(input, message) {
    const errorMessage = document.createElement("div");
    errorMessage.classList.add("erreur-validation-submit-select");
    errorMessage.setAttribute("data-i18n-key", "messages.steps.contactDetails.incompleteFieldMessage");
    errorMessage.textContent = message;

    insertAfter(errorMessage, input.parentNode);
}

    
function showErrorMessageSubmit(input, message) {
    const errorMessage = document.createElement("div");
    errorMessage.classList.add("erreur-validation-submit");
    errorMessage.setAttribute("data-i18n-key", "messages.steps.contactDetails.incompleteFieldMessage");
    errorMessage.textContent = message;

    input.parentNode.insertBefore(errorMessage, input.nextSibling);
}

function checkEmail(email) {
    return validator.isEmail(email);
}

function validatePhoneNumber(phoneNumber, locale) {
    // Utiliser la fonction isMobilePhone pour valider le numéro de téléphone
    const isValid = validator.isMobilePhone(phoneNumber, locale);

    return isValid;
}

const allInputs = document.querySelectorAll("input,select,textarea");
const step1Input = document.querySelector(".step1 select");
const step2Input = document.querySelectorAll(".step2 select");
const step3Input = document.querySelector(".step3 select");

step1Input.addEventListener("change", () => {
    // Vérifier si un élément avec la classe .erreur-validation existe
    const erreurValidationElement = document.querySelector(".step1 .erreur-validation");

    // Supprimer l"élément s"il existe
    if (erreurValidationElement) {
        erreurValidationElement.remove();
    }
});

step2Input.forEach(input => {
    input.addEventListener("change", () => {
        // Vérifier si un élément avec la classe .erreur-validation existe dans .step2
        const erreurValidationElement = document.querySelector(".step2 .erreur-validation");

        // Supprimer l"élément s"il existe
        if (erreurValidationElement) {
            erreurValidationElement.remove();
        }
    });
});


step3Input.addEventListener("change", () => {
    // Vérifier si un élément avec la classe .erreur-validation existe
    const erreurValidationElement = document.querySelector(".step3 .erreur-validation-submit-select");

    // Supprimer l"élément s"il existe
    if (erreurValidationElement) {
        erreurValidationElement.remove();
    }
});


allInputs.forEach(input => {
    input.addEventListener("change", () => {
        // Obtient le prochain élément frère de l'input
        let nextSibling = input.nextSibling;

        // Vérifie si le prochain frère existe et s'il a la classe "erreur-validation-submit"
        if (nextSibling && nextSibling.classList && nextSibling.classList.contains("erreur-validation-submit")) {
            nextSibling.remove();
        }
    });
});

const openFormButton = document.querySelector("[data-open-form]");
const formPopup = document.querySelector("[data-form-popup]");
const closePopup = document.querySelector("[data-hide-popup]");
openFormButton.addEventListener("click", function(){
    formPopup.classList.add("open");
    // window.location.hash = "open-contact-form";
    window.history.pushState({}, null, "contact-form");
    directContact = true;
});

closePopup.addEventListener("click", function(){
    formPopup.classList.remove("open");
    history.replaceState(null, null, " ");
});

